import { flyInOut, staggeredCards, fadeIn, fade, zFade, customPosition, Cart, ShareMenu, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop, steppedFly, storeFilters, storetitle,viewInfo,viewDesc,winkey, productAnim, listAnimation, animateOpen, rotateOpen, rotateDown } from '../animations';
import { Component, OnInit, ViewChild, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectComponent } from 'ng-select';
import { Observable } from 'rxjs/Rx';

import { environment } from '../../environment';

import { StoreService } from '../../services/store.service';
import { UserService } from '../../services/user.service';

import { Product } from '../../models/product';
import { Category } from '../../models/category';
import { Account } from '../../models/account';
import { Item } from '../../models/item';
import { Currency } from '../../models/currency';
import { Filter } from '../../models/filter.constructor';

declare var $: any
declare var MasterSlider: any

@Component({
  selector: 'products',
  templateUrl: './products.component.html',
  inputs: [ 'productsPerPage', 'hideHeader', 'showFilters', 'staggerAnimate' ],
  providers: [ StoreService, UserService ],
  animations: [ flyInOut, staggeredCards, fadeIn, fade, zFade, customPosition, ShareMenu, Cart, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop, steppedFly, storeFilters, storetitle, viewInfo, viewDesc, winkey, productAnim, listAnimation,  animateOpen, rotateOpen, rotateDown ]
})

export class ProductsComponent implements OnInit {

	slideOne: Array<any> = [];
	slideTwo: Array<any> = [];

	@Input() resetCart = false;
	@Input() productsPerPage:any = 10;
	@Input() hideHeader:any = false;
	@Input() showFilters:any = false;
	@Input() staggerAnimate:boolean = true;

	@Output() addedProductoCart:EventEmitter<string> = new EventEmitter();

	@ViewChild('priceSort') priceSort: SelectComponent;
	@ViewChild('categoriesSort') categoriesSort: SelectComponent;
	@ViewChild('itemsSort') itemsSort: SelectComponent;

	productquery = new Filter();
	selection: Array<any> = [];
	cartItems: Product;
	allproducts: Product;
	products: Product;
	purchased: Product;
	categories: Category;
	productcategories: Category;
	parentcategories: Category;
	currency: Currency;
	currencies: Currency;
	accounts: Account;
	items: Item;

	environment = environment;
	numberofproducts: number;
	loadingCart: boolean;
	staggeredFlow: any;
	headerHeight: any;
	headerAlign: any;
	selected: number;
	subtitle: string;
	flips: boolean;
	title: string;
	custom: any;
	header: any;

	productPage = 0;
	currencyOpen = -1;
	selectedImage = 0;
	selectedProduct = 0;
	loadingItems = 9;
	searchitems = null;
	flashCart = false;
	filtersActive = false;
	productPages = true;
	hasProducts = null;
	optionsModel: any[];
	sortOptions: any[];
	cart: any[];
	total: any;
	sidebar: any;
	showCards = -1;
	viewPanel = ['both'];
	storeAdvert = 'false';
	showProductDetails = 'false';
	enableCurrencySelector = false;
	hideOwned = false;

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {

    if ( event.code == 'ArrowRight' ) {
      this.nextProduct();
    }

    if ( event.code == 'ArrowLeft' ) {
      this.prevProduct();
    }

  }

	constructor(private storeService: StoreService,
				private userService: UserService,
				private route: ActivatedRoute,
				private sanitizer: DomSanitizer,
				private router: Router) {
		
		this.sortOptions = [
			{ value: 'asc', label: 'Lowest Price' },
			{ value: 'desc', label: 'Highest Price' }
		];
		
		this.slideOne[0] = 'true';
		this.slideTwo[0] = 'true';
	}


	/**
	* Ordering and Sorting
	**/

	changeSort(selection, type?) { 
		this.productquery.sort = selection.value;
		this.filtersActive = true;
	}

	changeCategories(selection, type?) { 
		this.productquery.category = selection.value;
		this.filtersActive = true;
	}

	filterItems(selection, type?) {
		this.productquery.filterItems = selection.value;
		this.filtersActive = true;
	}

	clearProductFilter() {
		this.clearFilter();
	}

	clearFilter() {
		this.filtersActive = false;
		this.productquery.sort = 'ASC';
		this.productquery.category = null;
		this.productquery.filterItems = '';
	}

	areFiltersActive( type ) {
		if ( this[type+'query'].sort != 'ASC' ) {
			return true;
		} else if ( this[type+'query'].category != null ) {
			return true;
		} else if ( this[type+'query'].filterItems != '') {
			return true;
		} else {
			return false;
		}
	}


	/**
	* Cart Handling
	**/

	addToCart(product, i) {

		if ( product.limit == 0 || product.limit > product.owns ) {

			if ( this.inCart(product.id) ) {

				this.router.navigate(['/checkout']);

			} else if (product.instock && !this.inCart(product.id) ) {
				this.storeService.addToCart(product.id);
				this.loadingCart = true;
        		this.addedProductoCart.emit(product);
				this.getCart();
			}
		}
	}

	addQuantity(product) {
		this.storeService.addQuantity(product.id);
		this.getCart();
	}

	
	subtractQuantity(product) {
		product.quantity--;
		if ( product.quantity == 0 ) {
			this.showProductDetails = 'false';
		}
		this.removeFromCart(product.id);
	}

	updateCartButton() {
	 	this.flashCart = true;
	 	setTimeout( () => { this.flashCart = false; }, 5000);
	}

	removeFromCart(productIndex) {
		this.storeService.removeFromCart(productIndex);
		this.getCart();
	}


	getCart() {
		this.cart = this.storeService.getCartContents();
		this.custom = this.storeService.getItemContents();
		this.updateCartButton();
		// Promise.resolve( this.storeService.getProducts(this.cart) ).then((cartdata) => {
		// 	this.cartItems = cartdata;
		// 	this.loadingCart = false;
		// });
	}



	inCart( id ) {
		
		let incart = false;
		if ( this.cart.indexOf( id ) > -1 ) {
			incart = true;
		}

		return incart;
	}

	nextProduct() {
		if ( this.numberofproducts-1 > this.selectedProduct ) {
			this.selectedImage = 0;
			this.selectedProduct = this.selectedProduct+1;
		}
	}

	prevProduct() {
		if ( this.selectedProduct > 0 ) {
			this.selectedImage = 0;
			this.selectedProduct = ( this.selectedProduct > 0 ) ? this.selectedProduct-1 : this.selectedProduct;
		}
	}

	createRange(number) {
		var items: number[] = [];
		for(var i = 1; i <= number; i++) { items.push(i); }		
		return items;
	}

	/**
	* Effects / Animations
	**/
	stagger(t = 90) {
		if (this.showCards < this.numberofproducts) {
			this.showCards++;
			setTimeout( () => { this.stagger(t); }, t);
		} else { 
			this.showCards = this.numberofproducts;
		}
	}


	/**
	* Currency Handling
	**/
	getCurrencies() {
		if ( environment.currencies ) {
			Promise.resolve(this.storeService.getCurrencies()).then((c) => {
				this.currencies = c;
				Promise.resolve(this.storeService.getCurrency()).then((c) => {
					this.currency = c[0];
				});
			});
			Promise.resolve(this.storeService.enableCurrencySelector()).then((bool) => {
				this.enableCurrencySelector = bool;
			});
		}
	}

	openCurrency(y) {
		this.currencyOpen = (this.currencyOpen >= 0) ? -1 : y;
	}

	changeCurrency(currency) {
		this.currency = currency;
		this.storeService.changeCurrency(currency);
	}

	inAccount( productidentifier ) {
		Promise.resolve( this.storeService.countItemsInAccount( productidentifier ) ).then((accountCount) => {
			return accountCount;
		});
	}

    /* On with the show */
	ngOnInit() {

		this.headerHeight = 780;
		this.title = 'Game Editions';
		this.subtitle = 'Equip your character for survival';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/video/video.jpg") 10%' );

		this.sidebar = 'closed';
		this.productquery.sort = 'ASC';
		this.productquery.category = null;
		this.productquery.filterItems = '';
		
		/* 
		* Cart System
		*/

		this.getCart();
		
		Promise.resolve(this.storeService.loadProducts()).then( (storeproducts) => {
			this.products = storeproducts;
			this.allproducts = storeproducts;
			this.hasProducts = true;
			setTimeout( () => { this.stagger(90); }, 100);
			
		});

		this.storeService.countProducts().subscribe( productcount => {
			this.numberofproducts = productcount;
		});

		this.hideOwned = this.storeService.ownedHidden();

		// Promise.resolve(this.storeService.getCustomizerContents()).then((c) => {
		// 	this.custom = c;
		// });

		// Promise.resolve(this.storeService.getCategories()).then((categories) => {
		// 	this.categories = categories;
		// });

		// Promise.resolve(this.storeService.getParentCategories()).then((categories) => {
		// 	this.parentcategories = categories;
		// });

		// Promise.resolve(this.storeService.getItemsWithProducts()).then((items) => {
		// 	this.items = items;
		// });

		Promise.resolve( this.storeService.getItems() ).then( (items) => {
			this.items = items;
		}); 

		this.getCurrencies();
		
		$('html, body').animate({scrollTop: 0 }, 210);
  	}

  	ngAfterViewInit() {
  		
  		/**
		 * Product Sliders 
		**/
		
		if ( !this.hideHeader ) {
			
			var slider = new MasterSlider();

			slider.setup('masterslider' , {
				width:1170,
				view:"flow",
				fullwidth:true,
				height: this.headerHeight,
				autoheight: true,
				loop: true,
				autoplay: false, // debugg = false
				keyboard: true,
				speed: 10,
				instantStartLayers: true,
				filters: {
					opacity: 0.7,
					brightness: 2
				}
			});

			// adds Arrows navigation control to the slider.
			slider.control('arrows');

			//slider.control('timebar');
			// MSScrollParallax.setup(slider);
			
			// Create an internal slider for images 
			// for (var i = $('.innerslider').length; i >= 0; i--) {
			// 	var productslider = new MasterSlider();
			// 	productslider.setup('innerslider'+i, {
			// 		width:223,
			// 		height:200,
			// 		view: "fade",
			// 		loop: true,
					
			// 	});
			// 	productslider.control('bullets' , {autohide:false  , dir:"h", align:"bottom"});
			// 	productslider.control('arrows' , {autohide:false})
			// }
		}


  	}

  	ngForCallback(i) {
		this.viewPanel[i] = 'both';
	}


}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/store/products/products.component.ts